/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RecordScope {
  WORKSPACE = 'workspace',
  TEAM = 'team',
  PRIVATE = 'private',
}
